<template>
  <section class="evidence-review-view">
    <AskReportChips :report-view="reportView" />

    <section v-if="evidenceItems.length" class="mode-card">
      <p class="section-label">Evidence</p>
      <div class="evidence-items">
        <article v-for="(item, index) in evidenceItems" :key="`evidence-item-${index}`" class="evidence-item">
          <p class="evidence-item__title">{{ item.title }}</p>
          <p v-if="item.detail" class="mode-text">{{ item.detail }}</p>
          <ul v-if="item.refs.length" class="mode-list">
            <li v-for="(ref, refIndex) in item.refs" :key="`evidence-ref-${index}-${refIndex}`">
              {{ ref }}
            </li>
          </ul>
        </article>
      </div>
    </section>

    <section v-if="followupQuestions.length" class="mode-card">
      <p class="section-label">Suggested follow-up questions</p>
      <ul class="mode-list">
        <li v-for="(item, index) in followupQuestions" :key="`followup-${index}`">
          {{ item }}
        </li>
      </ul>
    </section>

    <section v-if="caveats.length" class="mode-card">
      <p class="section-label">Data Sources & Limits</p>
      <ul class="mode-list">
        <li v-for="(item, index) in caveats" :key="`caveat-${index}`">
          {{ item }}
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
import AskReportChips from '@/components/roster/ask/AskReportChips.vue'

export default {
  name: 'EvidenceReviewView',
  components: {
    AskReportChips,
  },
  props: {
    reportView: {
      type: Object,
      default: () => null,
    },
    signalStrength: {
      type: Object,
      default: () => ({}),
    },
    evidenceItems: {
      type: Array,
      default: () => [],
    },
    followupQuestions: {
      type: Array,
      default: () => [],
    },
    caveats: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.evidence-review-view {
  display: flex;
  flex-direction: column;
  gap: $space-4;
}

.mode-card {
  border: 1px solid $color-border;
  border-radius: $radius-md;
  background: $color-surface;
  padding: $space-3;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.03);
}

.section-label {
  margin: 0 0 $space-1;
  font-size: $font-size-xs;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: $color-text-strong;
}

.mode-text,
.evidence-item__title {
  margin: 0;
}

.evidence-items {
  display: flex;
  flex-direction: column;
  gap: $space-3;
}

.evidence-item {
  display: flex;
  flex-direction: column;
  gap: $space-2;
}

.evidence-item + .evidence-item {
  padding-top: $space-3;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}

.evidence-item__title {
  font-weight: 700;
}

.mode-list {
  margin: 0;
  padding-left: 1.2rem;
  list-style-type: disc;
}

.mode-list li + li {
  margin-top: $space-2;
}
</style>
